import Lottie from 'lottie-react';
import React from 'react';
import Fan from "../Animation/fan.json";
import { FiTool, FiSettings, FiPlusCircle, FiHome, FiShoppingCart, FiTruck } from "react-icons/fi";

// Predefined cool gradients
const gradientClasses = [
  "from-blue-100 to-blue-300",
  "from-cyan-100 to-cyan-300",
  "from-teal-100 to-teal-300",
  "from-sky-100 to-sky-300",
  "from-indigo-100 to-indigo-300",
  "from-purple-100 to-purple-300"
];

const Services = () => {
  const services = [
    {
      title: "AC Repair & Service",
      description: "Restore your AC to peak performance with anti-rust coating, cleaning, noise reduction, leakage fix, and gas filling.",
      icon: <FiTool />,
      image: "/service_details_1.webp"
    },
    {
      title: "HVAC Repair & Service",
      description: "Comprehensive HVAC system repair and maintenance to ensure year-round comfort.",
      icon: <FiSettings />,
      image: "https://tse1.mm.bing.net/th?id=OIP.EyCqpGLNnPEE7CxNx7vR9wHaEr&pid=Api&P=0&h=180"
    },
    {
      title: "AC Installation and Deinstallation",
      description: "Expert AC installation and safe removal services for all types of air conditioners.",
      icon: <FiPlusCircle />,
      image: "/service_details_4.webp"
    },
    {
      title: "AC Work for Industrial, Commercial, Residential & Office",
      description: "Specialized AC solutions for industries, commercial spaces, offices, and residential buildings.",
      icon: <FiHome />,
      image: "https://tse2.mm.bing.net/th?id=OIP.SR5toMTCu_crlzfdiTfU1QHaEK&pid=Api&P=0&h=180"
    },
    {
      title: "Old AC Sale and Purchase",
      description: "Hassle-free buying and selling of top-brand air conditioners at competitive prices.",
      icon: <FiShoppingCart />,
      image: "https://tse1.mm.bing.net/th?id=OIP.QXnzrQGFg0_Y9KWboXFXxwHaFj&pid=Api&P=0&h=180"
    },
    {
      title: "AC on Rent",
      description: "Affordable AC rental services ideal for short-term and long-term requirements.",
      icon: <FiTruck />,
      image: "https://i.pinimg.com/originals/81/f7/dc/81f7dcc16307e15b96a587d267628e3f.png"
    }
  ];

  return (
    <div className='w-full min-h-screen py-20 px-4 sm:px-8 lg:px-24 relative' style={{
      backgroundImage: `url("/service_bg_2.svg")`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
    }}>
      <div className='container mx-auto'>
        {/* Heading */}
        <div className='flex items-center gap-2'>
          <Lottie className='w-6' animationData={Fan} />
          <h1 className='text-xl sm:text-2xl text-orange-500 font-bold'>OUR SERVICES</h1>
        </div>
        <p className='text-2xl sm:text-3xl lg:text-5xl font-bold mt-4'>
          Where Every Breathe Feels <br className="hidden sm:block" /> Fresh And Cool
        </p>

        {/* Services Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-12">
          {services.map((service, index) => {
            const gradient = gradientClasses[index % gradientClasses.length];
            return (
              <div
                key={index}
                className={`relative group bg-gradient-to-br ${gradient} border border-white/30 rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 flex flex-col`}
              >
                {/* Dark hover overlay */}
                <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-40 transition duration-300 z-10"></div>

                {/* Image */}
                <div className="w-full h-48 sm:h-56 overflow-hidden z-0">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>

                {/* Content */}
                <div className="p-6 flex-1 flex flex-col bg-white bg-opacity-70 backdrop-blur-sm z-10 relative">
                  <div className="flex items-center mb-4">
                    <div className="text-orange-500 mr-3 text-2xl">
                      {service.icon}
                    </div>
                    <h3 className="text-xl font-bold text-gray-800">{service.title}</h3>
                  </div>
                  <p className="text-gray-700 mb-6 flex-1">{service.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Services;
